import * as R from 'ramda';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';


export const INPUT = R.memoizeWith(
  (
    borderColor: string = COLORS.LIGHT_GREY,
    textColor: string   = COLORS.DARK_GREY,
  ) => `${borderColor}${textColor}`,
  (
    borderColor: string = COLORS.LIGHT_GREY,
    textColor: string = COLORS.DARK_GREY,
  ) => css`
    height: 35px;
    padding: 0 12px;
    color: ${textColor};
    box-sizing: border-box;
    border: 1px solid ${borderColor};
    border-radius: 8px;
    
    ::placeholder {
      color: ${COLORS.FIELD_GREY};
    }
  `,
);
